import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import { MaterialIcon } from '../MaterialIcon';

const FileList = styled.ul`
    list-style-type: none;
    padding: 0;
    border: 1px solid #cccccc;
    border-radius: 6px;
`;

const FileListItem = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid #cccccc;
    :last-child {
        border-bottom: none;
    }
`;

const ModifiedIcon = styled(MaterialIcon)`
    cursor: pointer;
    :hover {
        color: #000;
    }
`;

export const EditableList = ({ removeItem, listItems = [] }) => {
    return (
        <FileList>
            {listItems.map(({ label, key }) => (
                <FileListItem key={key}>
                    {label}
                    {typeof removeItem === 'function' ? (
                        <ModifiedIcon icon={`close`} intent={`muted`} size={18} onClick={() => removeItem(key)} />
                    ) : null}
                </FileListItem>
            ))}
        </FileList>
    );
};

export default EditableList;

EditableList.propTypes = {
    removeItem: PropTypes.func,
    listItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            key: PropTypes.string
        })
    )
};
